<template>
  <main-template>
    <v-row>
      <v-col>
        <div class="d-flex justify-space-between align-center">
          <h1>
            <v-btn color="primary" x-small text @click="goBack">
              <v-icon left> fa fa-angle-left </v-icon>
            </v-btn>
            Minhas Faltas Justificadas
            <e-help-tooltip
              text="Consulte e envie suas solicitações de faltas justificadas com atestados ou comprovantes."
            />
          </h1>

          <v-btn color="primary" :to="{ name: 'colaboradores.faltasJustificadas.nova' }">
            <v-icon left small>mdi-plus</v-icon>
            Nova Justificativa de Falta
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="faltas"
              :loading="carregando"
              no-data-text="Nenhuma falta justificada solicitada até o momento."
            >
              <template v-slot:item.periodo="{ item }">
                {{ formatarData(item.data_inicio) }}
                <span v-if="item.data_fim"> até {{ formatarData(item.data_fim) }}</span>
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="statusColor(item.status)"
                  small
                  dark
                  class="text-uppercase font-weight-bold"
                >
                  {{ item.status || "Pendente" }}
                </v-chip>
              </template>

              <template v-slot:item.comprovante="{ item }">
                <v-btn
                  v-if="item.tem_documento || item.documento_path"
                  icon
                  small
                  color="primary"
                  @click="visualizarDocumento(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <span v-else class="caption grey--text">Sem anexo</span>
              </template>

              <template v-slot:item.acoes="{ item }">
                <!-- Editar / Excluir só se pendente -->
                <template v-if="item.status === 'pendente'">
                  <v-btn icon small color="warning" class="mr-1" @click="editarFalta(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn icon small color="error" @click="confirmarExclusao(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span v-else class="caption grey--text">Finalizado</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de confirmação de exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="450px">
      <v-card>
        <v-card-title class="headline text-h6 red--text">Excluir Solicitação?</v-card-title>
        <v-card-text>
          Tem certeza de que deseja excluir esta solicitação de falta justificada? Esta ação não
          pode ser desfeita.
        </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn text @click="dialogExclusao = false">Cancelar</v-btn>
          <v-btn color="error" :loading="excluindo" @click="excluirFalta">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "FaltaJustificadaPage",
  data() {
    return {
      carregando: false,
      faltas: [],
      headers: [
        { text: "Período da Falta", value: "periodo" },
        { text: "Motivo", value: "motivo" },
        { text: "Status", value: "status" },
        { text: "Comprovante", value: "comprovante", sortable: false },
        { text: "Ações", value: "acoes", sortable: false, align: "right" },
      ],
      dialogExclusao: false,
      faltaSelecionada: null,
      excluindo: false,
    };
  },
  mounted() {
    this.carregarFaltas();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async carregarFaltas() {
      try {
        this.carregando = true;
        const res = await this.$services.colaboradorPontosService.listarMinhasFaltasJustificadas();
        this.faltas = Array.isArray(res) ? res : res.data || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    statusColor(status) {
      switch (status) {
        case "aprovado":
          return "success";
        case "reprovado":
          return "error";
        case "pendente":
        default:
          return "warning";
      }
    },
    formatarData(val) {
      if (!val) return "";
      const datePart = val.split("T")[0];
      const [ano, mes, dia] = datePart.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    async visualizarDocumento(item) {
      try {
        await this.$services.colaboradorPontosService.meuDocumentoFalta(item.id);
      } catch (error) {
        this.$handleError(error);
      }
    },
    editarFalta(item) {
      this.$router.push({
        name: "colaboradores.faltasJustificadas.nova",
        query: { id: item.id },
      });
    },
    confirmarExclusao(item) {
      this.faltaSelecionada = item;
      this.dialogExclusao = true;
    },
    async excluirFalta() {
      if (!this.faltaSelecionada) return;
      try {
        this.excluindo = true;
        await this.$services.colaboradorPontosService.excluirMinhaFaltaJustificada(
          this.faltaSelecionada.id
        );
        this.dialogExclusao = false;
        this.carregarFaltas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindo = false;
      }
    },
  },
};
</script>
